import React from 'react';

import {MainLayout} from 'widgets/layout';

import {Payments} from 'features/payment';

import NotFound from 'shared/ui/ErrorPage/NotFoundPage';

import {isTranslate} from '../../shared/lib/lang';

const PaymentsPage: React.FC = () => {
    if (isTranslate()) {
        return <NotFound/>
    }
    
    return (
        <MainLayout>
            <Payments />
        </MainLayout>
    );
};

export default PaymentsPage;